import React from 'react';
import { func } from 'prop-types';
import { Mutation } from 'react-apollo';

import { SAVE_STORY } from 'graphql/saveStory';

const SaveStoryMutation = props => (
  <Mutation mutation={SAVE_STORY}>
    {saveStory => props.children(saveStory)}
  </Mutation>
);

SaveStoryMutation.propTypes = {
  children: func.isRequired
};

export default SaveStoryMutation;
